var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_506_4207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9989 0.293945C6.8812 0.293945 0.292969 6.88218 0.292969 14.9998C0.292969 23.1175 6.8812 29.7057 14.9989 29.7057C23.1165 29.7057 29.7047 23.1175 29.7047 14.9998C29.7047 6.88218 23.1165 0.293945 14.9989 0.293945ZM21.8224 10.2939C21.6018 12.6175 20.6459 18.2645 20.1606 20.8675C19.9547 21.9704 19.543 22.3381 19.1606 22.3822C18.3077 22.4557 17.6606 21.8234 16.8371 21.2792C15.543 20.4263 14.8077 19.8969 13.5577 19.0734C12.1018 18.1175 13.043 17.5881 13.8812 16.7351C14.1018 16.5145 17.8665 13.0881 17.94 12.7792C17.9502 12.7325 17.9489 12.6839 17.9361 12.6378C17.9233 12.5916 17.8994 12.5493 17.8665 12.5145C17.7783 12.441 17.6606 12.4704 17.5577 12.4851C17.4253 12.5145 15.3665 13.8822 11.3518 16.5881C10.7636 16.9851 10.2341 17.191 9.76356 17.1763C9.23414 17.1616 8.23414 16.8822 7.48414 16.6322C6.55767 16.3381 5.83709 16.1763 5.89591 15.6616C5.92532 15.3969 6.29297 15.1322 6.98415 14.8528C11.2783 12.9851 14.1312 11.7498 15.5577 11.1616C19.6459 9.45571 20.4841 9.16159 21.043 9.16159C21.1606 9.16159 21.44 9.191 21.6165 9.33806C21.7636 9.45571 21.8077 9.61747 21.8224 9.73512C21.8077 9.82336 21.8371 10.0881 21.8224 10.2939Z",
    fill: "#80A1FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_506_4207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.874286ac380e1c97bee8d95fc5798e6e.svg";
export { ForwardRef as ReactComponent };